module.exports = __webpack_public_path__ + "static/media/cardback.28179a5c.jpg";